import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { fetchTaskCounterUserTemplates } from "../miscellaneous/fetchTaskCounterSubmission";
import { TaskCounterUserTemplate } from "../types/TaskCounterTypes";

let cachedTemplates: TaskCounterUserTemplate[] | null = null;

export const useTaskCounterTemplates = (): TaskCounterUserTemplate[] => {
  const [templates, setTemplates] = useState<TaskCounterUserTemplate[]>(
    cachedTemplates ?? []
  );

  const mutation = useMutation(fetchTaskCounterUserTemplates, {
    onSuccess: (res) => {
      if (res.status === 200) {
        cachedTemplates = res.data;
        setTemplates(res.data);
      }
    },
  });

  useEffect(() => {
    if (!cachedTemplates) {
      mutation.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return templates;
};
